import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'personal',
  footer: 'personal',
}

const pageBrand: PageBrand = 'consumer'

export const consumer = new LineOfBusinessConfig(geConfig, pageBrand)
